import React from "react";
import { Link } from "react-router-dom";
import { Target, Truck, Users, TrendingUp, ArrowRight } from "lucide-react";

const TRUCK_IMG =
  "https://images.unsplash.com/photo-1586191582056-b7f0386fce27?auto=format&fit=crop&w=1600&q=80";

const pillars = [
  { icon: Target, title: "Twój cel", sub: "nasza misja", desc: "Skupiamy się na tym, co naprawdę ważne." },
  { icon: Truck, title: "Transport", sub: "to my", desc: "Doświadczenie, które pracuje na Twój sukces." },
  { icon: Users, title: "Wsparcie", sub: "to przewaga", desc: "Partner, na którym możesz polegać każdego dnia." },
  { icon: TrendingUp, title: "Razem tworzymy", sub: "dobry zespół!", desc: "Lepsze decyzje, lepsze wyniki, lepsza przyszłość." },
];

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative pt-32 md:pt-28 pb-0 min-h-[100vh] overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={TRUCK_IMG}
          alt=""
          className="w-full h-full object-cover opacity-55"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0a0a0a] via-[#0a0a0a]/85 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/40" />
      </div>
      <div className="hero-glow top-[10%] right-[-10%]" />

      <div className="container-x relative z-10">
        <div className="max-w-[720px] pt-10">
          <div className="reveal">
            <span className="eyebrow">Przemysław Chudy • Doradztwo strategiczne</span>
          </div>

          <h1
            data-testid="hero-title"
            className="reveal delay-1 h-display mt-6 text-[clamp(26px,4.4vw,60px)] leading-[1.12] max-w-3xl"
          >
            <span className="block text-[#f5f1e8]">Pomagam firmom transportowym</span>
            <span className="block gold-gradient-text">działać lepiej, zarabiać więcej</span>
            <span className="block text-[#f5f1e8]">i rozwijać się mądrze.</span>
          </h1>

          <div className="reveal delay-2 gold-line mt-10" />

          <p
            data-testid="hero-subtitle"
            className="reveal delay-3 mt-7 text-[15px] md:text-[17px] leading-relaxed text-[#b8b3a7] max-w-[540px]"
          >
            Strategiczne wsparcie dla firm, które chcą się rozwijać, uporządkować
            operacje lub wyjść z trudnej sytuacji finansowej. Bez teorii — tylko
            konkretne rozwiązania z realnego rynku.
          </p>

          <div className="reveal delay-4 mt-10 flex flex-wrap items-center gap-5">
            <Link
              data-testid="hero-cta-primary"
              to="/kontakt"
              className="btn-gold"
            >
              Porozmawiajmy
              <ArrowRight size={16} />
            </Link>
            <Link
              data-testid="hero-cta-secondary"
              to="/oferta"
              className="btn-link"
            >
              Dowiedz się więcej
              <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      </div>

      {/* Pillars strip */}
      <div className="container-x relative z-10 mt-20 md:mt-28 pb-16">
        <div
          data-testid="hero-pillars"
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border border-[rgba(212,169,74,0.18)] bg-[#0e0e10]/80 backdrop-blur-sm"
        >
          {pillars.map((p, idx) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                data-testid={`pillar-${idx}`}
                className={`p-8 lg:p-10 group transition-colors ${
                  idx < pillars.length - 1 ? "lg:border-r border-[rgba(212,169,74,0.12)]" : ""
                } ${idx < 2 ? "md:border-r md:border-b-0 border-b border-[rgba(212,169,74,0.12)]" : "border-b md:border-b-0 border-[rgba(212,169,74,0.12)]"}`}
              >
                <Icon className="text-[var(--gold)] group-hover:scale-110 transition-transform" size={32} strokeWidth={1.3} />
                <div className="mt-5">
                  <div className="font-display text-[18px] tracking-[0.14em] uppercase text-[#f5f1e8]">
                    {p.title}
                  </div>
                  <div className="text-[11px] tracking-[0.28em] uppercase gold-text mt-1">
                    {p.sub}
                  </div>
                </div>
                <p className="mt-5 text-[14px] leading-relaxed text-[#b8b3a7]">
                  {p.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
